import { useEffect, useState } from 'react';
import { POLL_TIMEOUT_MS } from '@/lib/state-machine';

interface Props {
  pollStartedAt: number;
}

export function Polling({ pollStartedAt }: Props) {
  const [secondsLeft, setSecondsLeft] = useState(
    Math.max(0, Math.floor((POLL_TIMEOUT_MS - (Date.now() - pollStartedAt)) / 1000)),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = Math.max(
        0,
        Math.floor((POLL_TIMEOUT_MS - (Date.now() - pollStartedAt)) / 1000),
      );
      setSecondsLeft(remaining);
    }, 1000);
    return () => clearInterval(interval);
  }, [pollStartedAt]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <div className="w-16 h-16 border-4 border-brand-500 border-t-transparent rounded-full animate-spin mx-auto mb-6" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Esperando confirmación</h2>
        <p className="text-gray-500 mb-4">
          Tu pago está siendo procesado. Esto puede tardar unos segundos.
        </p>
        <p className="text-sm text-gray-400">
          Tiempo restante: {secondsLeft}s
        </p>
        <p className="text-xs text-gray-400 mt-6">
          Puedes cerrar esta página con seguridad. Tu pago seguirá procesándose.
        </p>
      </div>
    </div>
  );
}
